import { post, postJson, get,put } from '../axios'

// const RESOURCE_BASE_PATH = '/tbPhoneBinding';

//查询商家当前富信资质记录
export const getQualification = p => get(`sys-seller-media-qualification`, p);

//富信资质保存、提交接口
export const saveQualification = p => postJson(`sys-seller-media-qualification`, p);



